var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('img',{attrs:{"src":"/assets/images/spinner.png","alt":"","srcset":"/assets/images/spinner.png" + " 1x, " + "/assets/images/spinner@2x.png" + " 2x, " + "/assets/images/spinner@3x.png" + " 3x"}})])}]

export { render, staticRenderFns }